import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { ModalComponent } from '@shared/components/modal';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AIBtnEvent } from 'thkee-common';

@Component({
  selector: 'app-ai-button',
  standalone: true,
  imports: [AngularSvgIconModule, ModalComponent, FormsModule, FormlyModule, ReactiveFormsModule, NgClass],
  templateUrl: './ai-button.component.html',
  styleUrl: './ai-button.component.scss',
})
export class AiButtonComponent {
  @Input() label: string = $localize`Generate with AI`;
  @Input() type: 'btn-fill' | 'btn-transparent' | 'btn-icon' = 'btn-fill';
  @Input() prompt: boolean = false;
  @Input() promptLabel: string = '';
  @Input() promptPlaceholder: string = '';
  @Input() inputAppendClassAI!: string[];
  @Output() btnEvent = new EventEmitter<AIBtnEvent>();

  @ViewChild('promptModal') promptModal!: ModalComponent;
  formPrompt = new FormGroup({});
  modelPrompt = { prompt: '' };
  fieldsPrompt: FormlyFieldConfig[] = [
    {
      key: 'prompt',
      type: 'input',
      props: {
        label: '',
        wrapClass: 'gap-0',
        inputAppendClass: ['w-full'],
        hideLabel: true,
        placeholder: '',
        required: true,
      },
      hooks: {
        afterContentInit: (field) => {
          if (field.props) field.props['placeholder'] = this.promptPlaceholder;
        },
      },
    },
  ];

  btnAction() {
    if (this.prompt) {
      this.promptModal.open();
    } else {
      this.btnEvent.emit({ click: true });
    }
  }

  submitPrompt() {
    this.formPrompt.markAsTouched();
    if (this.formPrompt.invalid) return;
    this.btnEvent.emit({ click: true, promptValue: this.formPrompt.get('prompt')!.value });
    this.promptModal.close();
  }
}
